import client, { deserializer } from 'services/client'
import { toSnake } from 'change-object-case'

const URL = 'v2/notifications'

export async function getNotifications(params = {}) {
  const response = await client().get(URL, { params: toSnake(params) })
  return deserializer.deserialize(response)
}
